<div mat-dialog-title class="d-flex justify-content-between align-items-center">
    <h2 class="m-0">{{ parentData.title }}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>

  <div class="main_div" *ngIf="bookingDetails.length > 0">
    <!-- <div class="upper_div">
    </div> -->
        <!-- <h1>{{bookingDetails[0].customerInfo.name ? bookingDetails[0].customerInfo.name : 'New Customer'}}</h1>
        <p>{{bookingDetails[0].country_code ? bookingDetails[0].country_code : '-'}} {{bookingDetails[0].customerInfo.phone &&  bookingDetails[0].customerInfo.phone != 'null' ? bookingDetails[0].customerInfo.phone : '---'}}</p> -->
        <!-- <div style="display: flex;">
            <span class="make_grey">Booked for: </span><p class="add_margin_left">{{bookingDetails[0].bookingDate | date}}</p>
        </div>
        <div style="display: flex;">
            <span class="make_grey">Slot timing: </span><p class="add_margin_left make_bold">{{bookingDetails[0].bookingStartTime}} - {{bookingDetails[0].bookingEndTime}}</p>
        </div> -->
        <!-- <div class="chip_cont" style="padding: 10px 0px;">
            <mat-chip-list aria-label="Fish selection" class="mb-3">
                <div *ngFor="let item of bookingDetails[0].serviceInfo">
                    <mat-chip
                   
                    style="height: auto"                                                                                                                                                                                                            
              
                    >{{item.serviceName}} x {{item.qty}}
                    
                  </mat-chip>
                </div>
                <div *ngFor="let item of bookingDetails[0].custom_items">
                    <mat-chip
                   
                    style="height: auto"                                                                                                                                                                                                            
              
                    >{{item.item_name}} x {{item.item_qty}}
                    
                  </mat-chip>
                </div>
              
            </mat-chip-list>
          </div> -->
        


        <!-- new design start -->
       <div class="bookinght_sectiokl">
        <div class="row">
            <div class="col-md-6">
                <div class="sub_one sub_margin">
                  <div class="sub_one_cont">
                    <div>
                      <span class="material-icons icon_mat"> person </span>
                    </div>
                    <div class="entity_detail make_text_grey">
                       Name
                    </div>
                  </div>
                  <div class="sub_one_cont main_text">
                    <div class="entity_detail" style="margin-left: 30px; font-size: 16px;">
                        {{bookingDetails[0].customerInfo.name ? bookingDetails[0].customerInfo.name : 'New Customer'}}
                    </div>
                  </div>
                </div>
              </div>
    
              <div class="col-md-6">
                <div class="sub_one sub_margin">
                  <div class="sub_one_cont">
                    <div>
                      <span class="material-icons icon_mat"> call </span>
                    </div>
                    <div class="entity_detail make_text_grey">
                       Phone
                    </div>
                  </div>
                  <div class="sub_one_cont main_text">
                    <div class="entity_detail" style="margin-left: 30px; font-size: 16px;">
                        {{bookingDetails[0].country_code ? bookingDetails[0].country_code : '-'}} {{bookingDetails[0].customerInfo.phone &&  bookingDetails[0].customerInfo.phone != 'null' ? bookingDetails[0].customerInfo.phone : '---'}}
                    </div>
                  </div>
                </div>
              </div>
    
    
          <div class="col-md-6">
            <div class="sub_one sub_margin">
              <div class="sub_one_cont">
                <div>
                  <span class="material-icons icon_mat"> library_books </span>
                </div>
                <div class="entity_detail make_text_grey">
                    Booked for
                </div>
              </div>
              <div class="sub_one_cont main_text">
                <div class="entity_detail" style="margin-left: 34px;font-size: 16px;">
                    {{bookingDetails[0].bookingDate ? (bookingDetails[0].bookingDate | date) : (bookingDetails[0].booking_date | date)}}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="sub_one sub_margin">
              <div class="sub_one_cont">
                <div>
                  <span class="material-icons icon_mat"> calendar_month </span>
                </div>
                <div class="entity_detail make_text_grey">
                    Slot timing	
                </div>
              </div>
              <div class="sub_one_cont main_text">
                <div class="sub_one_cont main_text">
                    <div class="entity_detail" style="margin-left: 34px;font-size: 16px;">
                        {{bookingDetails[0].bookingStartTime}} - {{bookingDetails[0].bookingEndTime}}
                    </div>
                  </div>
              </div>
            </div>
          </div>
    
          <div class="col-md-6">
            <div class="sub_one sub_margin">
              <div class="sub_one_cont">
                <div>
                  <span class="material-icons icon_mat"> manage_accounts </span>
                </div>
                <div class="entity_detail make_text_grey">
                   Service
                </div>
              </div>
              <div class="sub_one_cont main_text">
                <div class="entity_detail" style="margin-left: 34px; font-size: 16px;">
                    <mat-chip-list aria-label="Fish selection" class="mb-3">
                        <div *ngFor="let item of bookingDetails[0].serviceInfo">
                            <mat-chip
                           
                            style="height: auto"                                                                                                                                                                                                            
                      
                            >{{item.serviceName}} x {{item.qty}}
                            
                          </mat-chip>
                        </div>
                       
                      
                    </mat-chip-list>
                </div>
              </div>
            </div>
          </div>
          <!--  -->
          <div class="col-md-6" *ngIf="bookingDetails[0].appointment_products">
            <div class="sub_one sub_margin">
              <div class="sub_one_cont">
                <div>
                  <span class="material-icons icon_mat"> inventory_2 </span>
                </div>
                <div class="entity_detail make_text_grey">
                   Products
                </div>
              </div>
              <div class="sub_one_cont main_text">
                <div class="entity_detail" style="margin-left: 34px; font-size: 16px;">
                    <mat-chip-list aria-label="Fish selection" class="mb-3">
                      
                        <div *ngFor="let item of bookingDetails[0].appointment_products">
                            <mat-chip
                           
                            style="height: auto"                                                                                                                                                                                                            
                      
                            >{{item.product_name}} x {{item.product_qty}}
                            
                          </mat-chip>
                        </div>
                      
                    </mat-chip-list>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6" *ngIf="bookingDetails[0].custom_items">
            <div class="sub_one sub_margin">
              <div class="sub_one_cont">
                <div>
                  <span class="material-icons icon_mat"> info </span>
                </div>
                <div class="entity_detail make_text_grey">
                   Other items
                </div>
              </div>
              <div class="sub_one_cont main_text">
                <div class="entity_detail" style="margin-left: 34px; font-size: 16px;">
                    <mat-chip-list aria-label="Fish selection" class="mb-3">
                      
                        <div *ngFor="let item of bookingDetails[0].custom_items">
                            <mat-chip
                           
                            style="height: auto"                                                                                                                                                                                                            
                      
                            >{{item.item_name}} x {{item.item_qty}}
                            
                          </mat-chip>
                        </div>
                      
                    </mat-chip-list>
                </div>
              </div>
            </div>
          </div>
         
        </div>
        </div>
        <!-- new design end -->


        <!--  -->
        <div class="bookinght_sectiokl" style="background: #fff;">
            <div class="row">
                <div class="col-md-12">
                    <div class="sub_one sub_margin">
                      <div class="sub_one_cont">
                        <div>
                          <span class="material-icons icon_mat"> schedule </span>
                        </div>
                        <div class="entity_detail make_text_grey">
                            Status
                        </div>
                      </div>
                      <div class="sub_one_cont main_text">
                        <div class="entity_detail" style="margin-left: 30px; font-size: 16px;">
                            {{bookingDetails[0].bookingStat}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="sub_one sub_margin">
                      <div class="sub_one_cont">
                        <div>
                          <span class="material-icons icon_mat"> receipt_long </span>
                        </div>
                        <div class="entity_detail make_text_grey">
                            Booking number
                        </div>
                      </div>
                      <div class="sub_one_cont main_text">
                        <div class="entity_detail" style="margin-left: 30px; font-size: 16px;">
                            {{bookingDetails[0].appointment_no}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="sub_one sub_margin">
                      <div class="sub_one_cont">
                        <div>
                          <span class="material-icons icon_mat"> receipt_long </span>
                        </div>
                        <div class="entity_detail make_text_grey">
                            Booking type
                        </div>
                      </div>
                      <div class="sub_one_cont main_text">
                        <div class="entity_detail" style="margin-left: 30px; font-size: 16px;">
                          {{bookingDetails[0].bookingType == 1 ? 'Shop booking' : (bookingDetails[0].bookingType == 0 ? 'Home booking' : 'Virtual booking' ) }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="sub_one sub_margin">
                      <div class="sub_one_cont">
                        <div>
                          <span class="material-icons icon_mat"> calendar_month </span>
                        </div>
                        <div class="entity_detail make_text_grey">
                            Booked on
                        </div>
                      </div>
                      <div class="sub_one_cont main_text">
                        <div class="entity_detail" style="margin-left: 30px; font-size: 16px;">
                            {{bookingDetails[0].creationDate | date}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="sub_one sub_margin">
                      <div class="sub_one_cont">
                        <div>
                          <span class="material-icons icon_mat"> description </span>
                        </div>
                        <div class="entity_detail make_text_grey">
                            Notes
                        </div>
                      </div>
                      <div class="sub_one_cont main_text">
                        <div class="entity_detail" style="margin-left: 30px; font-size: 16px;white-space: pre-line">
                            {{bookingDetails[0].note && bookingDetails[0].note != 'null' ? bookingDetails[0].note : 'No notes added'}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12" *ngIf="bookingDetails[0].employeeName && bookingDetails[0].employeeName != 'N/A'">
                    <div class="sub_one sub_margin">
                      <div class="sub_one_cont">
                        <div>
                          <span class="material-icons icon_mat"> verified_user </span>
                        </div>
                        <div class="entity_detail make_text_grey">
                            Attended by
                        </div>
                      </div>
                      <div class="sub_one_cont main_text">
                        <div class="entity_detail" style="margin-left: 30px; font-size: 16px;">
                            {{bookingDetails[0].employeeName}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="col-md-12" *ngIf="bookingDetails[0].bookingStatus != 4">
                    <div class="sub_one sub_margin">
                      <div class="sub_one_cont">
                        <div>
                          <span class="material-icons icon_mat"> person_check </span>
                        </div>
                        <div class="entity_detail make_text_grey">
                            Attended by
                        </div>
                      </div>
                      <div class="sub_one_cont main_text">
                        <div class="entity_detail" style="margin-left: 30px; font-size: 16px;">
                            {{bookingDetails[0].updateStatusDate | date : "medium"}}
                        </div>
                      </div>
                    </div>
                  </div> -->
                  <div class="col-md-12" *ngIf="bookingDetails[0].bookingStatus != 4 && bookingDetails[0].employeeName && bookingDetails[0].employeeName != 'N/A'">
                    <div class="sub_one sub_margin">
                      <div class="sub_one_cont">
                        <div>
                          <span class="material-icons icon_mat"> calendar_month </span>
                        </div>
                        <div class="entity_detail make_text_grey">
                            Attended at
                        </div>
                      </div>
                      <div class="sub_one_cont main_text">
                        <div class="entity_detail" style="margin-left: 30px; font-size: 16px;">
                            {{bookingDetails[0].updateStatusDate | date : "medium"}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12" *ngIf="bookingDetails[0].bookingStatus == 4">
                    <div class="sub_one sub_margin">
                      <div class="sub_one_cont">
                        <div>
                          <span class="material-icons icon_mat"> calendar_month </span>
                        </div>
                        <div class="entity_detail make_text_grey">
                            Completed at
                        </div>
                      </div>
                      <div class="sub_one_cont main_text">
                        <div class="entity_detail" style="margin-left: 30px; font-size: 16px;">
                            {{bookingDetails[0].updateStatusDate | date : "medium"}}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="sub_one sub_margin">
                      <div class="sub_one_cont">
                        <div>
                          <span class="material-icons icon_mat"> payments </span>
                        </div>
                        <div class="entity_detail make_text_grey">
                            Service cost
                        </div>
                      </div>
                      <div class="sub_one_cont main_text">
                        <div class="entity_detail" style="margin-left: 30px; font-size: 16px;">
                            {{bookingDetails[0].currency_symbol}}{{bookingDetails[0].price.toFixed(2)}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="sub_one sub_margin">
                      <div class="sub_one_cont">
                        <div>
                          <span class="material-icons icon_mat"> pending_actions </span>
                        </div>
                        <div class="entity_detail make_text_grey">
                            Payment status
                        </div>
                      </div>
                      <div class="sub_one_cont main_text">
                        <div class="entity_detail" style="margin-left: 30px; font-size: 16px;">
                            {{bookingDetails[0].paymentStat}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12" *ngIf="bookingDetails[0].paymentStatus && bookingDetails[0].paymentStatus != 0">
                    <div class="sub_one sub_margin">
                      <div class="sub_one_cont">
                        <div>
                          <span class="material-icons icon_mat"> analytics </span>
                        </div>
                        <div class="entity_detail make_text_grey">
                            Payment mode
                        </div>
                      </div>
                      <div class="sub_one_cont main_text">
                        <div class="entity_detail" style="margin-left: 30px; font-size: 16px;">
                            {{bookingDetails[0].paymentMode}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12" *ngIf="bookingDetails[0].paymentStatus && bookingDetails[0].paymentStatus != 0">
                    <div class="sub_one sub_margin">
                      <div class="sub_one_cont">
                        <div>
                          <span class="material-icons icon_mat"> payments </span>
                        </div>
                        <div class="entity_detail make_text_grey">
                            Payment amount
                        </div>
                      </div>
                      <div class="sub_one_cont main_text">
                        <div class="entity_detail" style="margin-left: 30px; font-size: 16px;">
                            {{bookingDetails[0].currency_symbol}}{{bookingDetails[0].customerPayment.toFixed(2)}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12" *ngIf="bookingDetails[0].paymentStatus && bookingDetails[0].paymentStatus != 0">
                    <div class="sub_one sub_margin">
                      <div class="sub_one_cont">
                        <div>
                          <span class="material-icons icon_mat"> payments </span>
                        </div>
                        <div class="entity_detail make_text_grey">
                            Payment due
                        </div>
                      </div>
                      <div class="sub_one_cont main_text">
                        <div class="entity_detail" style="margin-left: 30px; font-size: 16px;">
                            {{bookingDetails[0].currency_symbol}}{{bookingDetails[0].payment_due.toFixed(2)}}
                        </div>
                      </div>
                    </div>
                  </div>
            </div>
        </div>
        <!--  -->

        <!-- <div class="lower_div">
        </div> -->
            <!-- <div>
                <div style="display: flex;">
                    <span class="make_grey">Status: </span><p class="add_margin_left make_bold">{{bookingDetails[0].bookingStat}}</p>
                </div>
                <div style="display: flex;" *ngIf="bookingDetails[0].appointment_no">
                    <span class="make_grey">Booking number: </span><p class="add_margin_left make_bold">{{bookingDetails[0].appointment_no}}</p>
                </div>
                <div style="display: flex;">
                    <span class="make_grey">Booking type: </span><p class="add_margin_left make_bold">{{bookingDetails[0].bookingType == 1 ? 'Shop booking' : 'Home booking'}}</p>
                </div>
                <div style="display: flex;">
                    <span class="make_grey">Booked on: </span><p class="add_margin_left make_bold">{{bookingDetails[0].creationDate | date}}</p>
                </div>
                <div style="display: flex;">
                    <span class="make_grey">Notes: </span><p class="add_margin_left make_bold">{{bookingDetails[0].note && bookingDetails[0].note != 'null' ? bookingDetails[0].note : 'No notes added'}}</p>
                </div>
                <div style="display: flex;" *ngIf="bookingDetails[0].employeeName">
                    <span class="make_grey">Attended by: </span><p class="add_margin_left make_bold">{{bookingDetails[0].employeeName}}</p>
                </div>
                <div style="display: flex;" *ngIf="bookingDetails[0].bookingStatus != 4">
                    <span class="make_grey">Attended at: </span><p class="add_margin_left make_bold">{{bookingDetails[0].updateStatusDate | date : "medium"}}</p>
                </div>
                <div style="display: flex;" *ngIf="bookingDetails[0].bookingStatus == 4">
                    <span class="make_grey">Completed at: </span><p class="add_margin_left make_bold">{{bookingDetails[0].updateStatusDate | date : "medium"}}</p>
                </div>
              </div> -->
              <!-- <div>
                <div style="display: flex;">
                    <span class="make_grey">Service cost: </span><p class="add_margin_left make_bold">{{bookingDetails[0].currency_symbol}}{{bookingDetails[0].price}}</p>
                </div>
                <div style="display: flex;">
                    <span class="make_grey">Payment status: </span><p class="add_margin_left make_bold">{{bookingDetails[0].paymentStat}}</p>
                </div>
                <div style="display: flex;" *ngIf="bookingDetails[0].paymentStatus && bookingDetails[0].paymentStatus != 0">
                    <span class="make_grey">Payment mode: </span><p class="add_margin_left make_bold">{{bookingDetails[0].paymentMode}}</p>
                </div>
                <div style="display: flex;" *ngIf="bookingDetails[0].paymentStatus && bookingDetails[0].paymentStatus != 0">
                    <span class="make_grey">Payment amount: </span><p class="add_margin_left make_bold">{{bookingDetails[0].currency_symbol}}{{bookingDetails[0].customerPayment}}</p>
                </div>
                <div style="display: flex;" *ngIf="bookingDetails[0].paymentStatus && bookingDetails[0].paymentStatus != 0">
                    <span class="make_grey">Payment due: </span><p class="add_margin_left make_bold">{{bookingDetails[0].currency_symbol}}{{bookingDetails[0].payment_due}}</p>
                </div>
              </div> -->
     
          
    
  </div>

  </mat-dialog-content>